import btoa from "btoa";
import _ from "lodash";

import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

export const getWebEnv = function (locale, callback) {
  var env_base64 = btoa(publicConfig.env_handshake);

  var request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/web/${locale || "en-US"}`,
    method: "GET",
    headers: {
      Authorization: "Bearer " + env_base64,
    },
  };

  httpRequest(request_params, function (response) {
    return callback(response);
  });
};

export const serverGetWeb = function serverGet(callback) {
  var requestParams = {
    host: publicConfig.external_address,
    path: "/bookings/web/env",
    method: "GET",
  };

  httpRequest(requestParams, callback);
};

export const getMetros = (function () {
  var cache = {};
  var maxAge = 300000;

  function find(timeNow, callback) {
    var lastSave = cache.timestamp || 0;
    var timeSpan = timeNow - lastSave;
    find.saveEnv = function (env) {
      cache.metros = env.metros;
      cache.timestamp = timeNow;
      return callback(cache.metros);
    };
    // if metros has been saved,
    if (lastSave && timeSpan < maxAge) {
      return callback(cache.metros);
    }
    // Not in the cache, so compute the value and put it in the cache
    return getWebEnv("", find.saveEnv);
  }
  return find;
})();

export const findMetroByKey = function (keyValObject, callback) {
  getMetros(Date.now(), function (response) {
    var metro = _.find(response, function (m) {
      return m.name.toLowerCase() === keyValObject.name.toLowerCase();
    });
    var responseObject = {
      match: metro,
      available_metros: _.filter(response, { active: true }),
    };
    callback(responseObject);
  });
};

export const getActivities = function (callback) {
  var request_params = {
    host: publicConfig.external_address,
    path: "/activities",
    method: "GET",
  };

  httpRequest(request_params, (response) => {
    return callback(response);
  });
};

export const getTagActivities = function (callback) {
  var env_base64 = btoa(publicConfig.env_handshake);
  var request_params = {
    host: publicConfig.external_address,
    path: "/v1/env/activities",
    method: "GET",
    headers: {
      Authorization: "Bearer " + env_base64,
    },
  };

  httpRequest(request_params, function (response) {
    return callback(response);
  });
};

export const getAddOnsCategories = (locale, callback) => {
  const request_params = {
    host: publicConfig.external_address,
    path: `/v1/env/addons/${locale}`,
    method: "GET",
  };

  httpRequest(request_params, (response) => {
    return callback(response);
  });
};

export const getSpaceEnv = (locale, callback) => {
  const request_params = {
    host: publicConfig.external_address,
    path: "/v1/env/spaces" + "/" + locale,
    method: "GET",
  };

  httpRequest(request_params, (response) => {
    return callback(response);
  });
};
